import { PageLayout } from '@/components/feature/PageLayout';
import { CheckCircle, Phone } from 'lucide-react';

const seo = {
  title: 'Merci — Votre demande a bien été envoyée | Volet Charleroi',
  description: 'Nous avons bien reçu votre demande de devis pour la réparation de votre volet roulant. Nous vous recontacterons rapidement.',
  canonicalUrl: '/merci/',
  noindex: true,
};

export default function MerciPage() {
  return (
    <PageLayout seo={seo} showDevisForm={false}>
      <section className="py-20 md:py-32 bg-background-50">
        <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
          <div className="w-20 h-20 rounded-2xl bg-success-50 flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-success-500" />
          </div>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-700 mb-4">
            Merci pour votre demande !
          </h1>
          <p className="text-base md:text-lg text-foreground-500 mb-8">
            Nous avons bien reçu votre demande de devis. Notre équipe va l'étudier et vous recontactera dans les plus brefs délais, généralement sous 24 heures.
          </p>
          <p className="text-sm text-foreground-400 mb-10">
            En attendant, si votre problème est urgent, n'hésitez pas à nous appeler directement.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="tel:+3280020410"
              className="btn-primary text-base px-8 py-3.5 inline-flex items-center gap-2 w-full sm:w-auto justify-center"
            >
              <Phone className="w-5 h-5" />
              0800 20 410
            </a>
            <Link
              to="/"
              className="btn-outline text-base px-8 py-3.5 inline-flex items-center gap-2 w-full sm:w-auto justify-center"
            >
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}